import {
  HabitSchedule,
  ScheduleEntry,
  ScheduleEntryState,
  Timestamp,
} from '@griply/types';
import { addWeeks } from 'date-fns';

import { isBetween } from './lib/date-fns';

export type GetTimeframeCompletionsOptions = {
  startDate: Timestamp;
  endDate: Timestamp;
};

export type TimeframeCompletions = {
  /** The padded range — the month view renders completions either side of the timeframe. */
  completions: ScheduleEntry[];
  /** Only the ones inside the asked-for range. */
  timeframeCompletions: ScheduleEntry[];
};

const PADDING_WEEKS = 5;

// A completion is an entry that is `Complete` *and* carries a value: a 0-valued complete entry is
// a day that was opened and not filled in, not a completion.
export const getTimeframeCompletions = (
  schedules: HabitSchedule[],
  { startDate, endDate }: GetTimeframeCompletionsOptions,
): TimeframeCompletions => {
  const rangeStartDate = addWeeks(startDate, -PADDING_WEEKS);
  const rangeEndDate = addWeeks(endDate, PADDING_WEEKS);

  const completions = schedules
    .map(({ entries }) =>
      entries.filter(
        (entry) =>
          isBetween(entry.date, rangeStartDate, rangeEndDate) &&
          entry.state === ScheduleEntryState.Complete &&
          !!entry.value,
      ),
    )
    .flat(1);

  return {
    completions,
    timeframeCompletions: completions.filter((entry) =>
      isBetween(entry.date, startDate, endDate),
    ),
  };
};
